import { getImageList, getDate } from "./image-list.js";

(async function () {
  const loader = document.getElementById("loader");
  const heroContainer = document.getElementById("hero");
  const images = await getImageList();

  loader.style.display = "none";
  heroContainer.removeAttribute("style");

  if (images?.length >= 1) {
    const latestImage = images[0];
    const latestImg = document.createElement("img");
    latestImg.onload = () => {
      heroContainer.appendChild(document.createElement("p")).innerText =
        getDate(latestImage.url);
    };
    latestImg.alt = "Newest generated AI image";
    latestImg.width = "512";
    latestImg.height = "512";
    latestImg.fetchPriority = "high";
    latestImg.src = latestImage.url;
    heroContainer.appendChild(latestImg);
  }
})();
